import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { BusinessProfileLayout } from 'pages/settings/pages/compliance/pages/businessProfile/layout/BusinessProfileLayout'
import { BusinessProfilePage } from 'pages/settings/pages/compliance/pages/businessProfile/ui/businessProfilePage'

export const BusinessProfileRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<BusinessProfileLayout />}>
        <Route path={'/'} element={<BusinessProfilePage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
